import React from "react";
import Icon from "@mdi/react";
import { mdiRobotHappy } from "@mdi/js";
import { CircularProgress } from "@mui/material";
import { ListSidebar } from "layouts";
import styles from "../styles.module.scss";
import { clsx } from "@ismael1361/utils";
import type { PublicTeamDTO } from "shared/services";
import { useLocation } from "react-router-dom";

interface RenderSidebarProps {
	loadingTeams: boolean;
	teams: PublicTeamDTO[];
	setSelectedTeamId: (id: string) => void;
	onSelectAssistant: () => void;
}

export const RenderSidebar: React.FC<RenderSidebarProps> = ({ loadingTeams, teams, setSelectedTeamId, onSelectAssistant }) => {
	const location = useLocation();
	const teamPath = location.pathname.split("/team/")[1] ?? "";
	const teamId = teamPath.split("/")[0] || null;

	return (
		<ListSidebar
			footer={
				<div
					className={clsx(styles.assistantCard, !teamId && styles.assistantCardActive)}
					onClick={onSelectAssistant}
					role="button"
					tabIndex={0}
					onKeyDown={(e) => {
						if (e.key === "Enter" || e.key === " ") onSelectAssistant();
					}}
				>
					<div className={styles.assistantCardIcon}>
						<Icon
							path={mdiRobotHappy}
							size={0.9}
						/>
					</div>
					<div>
						<h3 className={styles.assistantCardTitle}>Meu assistente</h3>
						<p className={styles.assistantCardDesc}>Assistente pessoal</p>
					</div>
				</div>
			}
		>
			{loadingTeams ? (
				<div className={styles.loadingState}>
					<CircularProgress
						color="inherit"
						size={20}
					/>
				</div>
			) : (
				teams.map((team) => (
					<div
						key={team.id}
						className={clsx(styles.teamCard, teamId === String(team.id) && styles.teamCardActive)}
						onClick={() => setSelectedTeamId(String(team.id))}
					>
						<div className={styles.teamCardInfo}>
							<div className={styles.teamCardRow}>
								<span className={styles.teamCardName}>{team.name}</span>
							</div>
							<p className={styles.teamCardDesc}>{team.members?.length ?? 0} membros</p>
						</div>
					</div>
				))
			)}
		</ListSidebar>
	);
};
